export const FEIN_UPLOAD_TEMPLATE_NAME = 'FEINUploadTemplate.xlsx';

export const LOCATIONS_UPLOAD_TEMPLATE_NAME = 'LocationsTemplate.xlsx';

export const TRAK_DATA_TEMPLATE_NAME = 'TrakDataTemplate.xlsx';

export const PEO_UPLOAD_BY_PEO_PP_TEMPLATE_NAME = 'PeoUploadByPeoPayrollProviderTemplate.xlsx';

export const EMPLOYERS_UPLOAD_BY_PEO_PP_TEMPLATE_NAME =
  'EmployersUploadByPeoPayrollProviderTemplate.xlsx';

export const EMPLOYERS_UPLOAD_BY_PEO_TEMPLATE_NAME = 'EmployersUploadByPeoTemplate.xlsx';
